import { type RenderConfigVideoClip } from "@memento/types/render-config";
import { useEditor } from "src/components/Renderer/RendererProvider";
import { ToggleBlock } from "src/components/Renderer/ToggleBlock";

type EditClipMusicProps = {
  clip: RenderConfigVideoClip;
};

export const EditClipMusic = ({ clip }: EditClipMusicProps) => {
  const { setClipMusicMuted, clipPrefetchDetailsBySegmentId, setFrameToSeek } =
    useEditor();

  const skipToFrame =
    clipPrefetchDetailsBySegmentId[clip.segmentId]?.skipToFrame ?? 0;

  return (
    <ToggleBlock
      label="Mute background music"
      checked={clip.muteMusic}
      onChange={() => {
        setClipMusicMuted(clip.segmentId, !clip.muteMusic);
        setFrameToSeek({ frame: skipToFrame });
      }}
    />
  );
};
